var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rtos',{attrs:{"rto-categories":_vm.$store.getters['assessment/rtosByCategory'],"action-text":_vm.$t('general.back')},on:{"back":function($event){return _vm.$router.back()}}})}
var staticRenderFns = []

export { render, staticRenderFns }